var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTableDark(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Table"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M3.125 8.6875H3.0625V8.75V11.25V11.3125H3.125H6.25H6.3125V11.25V8.75V8.6875H6.25H3.125ZM7.5 8.6875H7.4375V8.75V11.25V11.3125H7.5H16.875H16.9375V11.25V8.75V8.6875H16.875H7.5ZM3.125 12.4375H3.0625V12.5V15V15.0625H3.125H6.25H6.3125V15V12.5V12.4375H6.25H3.125ZM16.875 15.0625H16.9375V15V12.5V12.4375H16.875H7.5H7.4375V12.5V15V15.0625H7.5H16.875ZM2.5 3.8125H17.5C17.6492 3.8125 17.7923 3.87176 17.8977 3.97725C18.0032 4.08274 18.0625 4.22582 18.0625 4.375V15C18.0625 15.3149 17.9374 15.617 17.7147 15.8397C17.492 16.0624 17.1899 16.1875 16.875 16.1875H3.125C2.81006 16.1875 2.50801 16.0624 2.28531 15.8397C2.06261 15.617 1.9375 15.3149 1.9375 15V4.375C1.9375 4.22582 1.99676 4.08274 2.10225 3.97725C2.20774 3.87176 2.35082 3.8125 2.5 3.8125Z",
    fill: "#272727",
    stroke: "#272727",
    strokeWidth: 0.125
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTableDark);
export default __webpack_public_path__ + "static/media/table-dark.c750e2144b19e75f11ed0bf7965661e7.svg";
export { ForwardRef as ReactComponent };